import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { postDataRequest } from '../common/commonfunction';
import { UserById } from '../common/api';
import { baseURL } from '../common/const';
import { showNotification } from '../common/Notification/ToastifyNotification';
import { Menu, MenuItem } from '@mui/material';

const Nav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleMouseEnter = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMouseLeave = () => {
        setAnchorEl(null);
    };
    const onClickItem = (item) => {
        setAnchorEl(null);
        navigate(`/tutoring-service`);
    };



    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        if (id) {
            postDataRequest(`${baseURL}/user/${id}`, {
                query: UserById,
                variables: {
                    userid: id,
                },
            }).then((resp) => {
                if (resp?.errors && resp?.errors[0]?.message) {
                    showNotification(resp?.errors[0]?.message, 'error');
                } else {
                    setUserData(resp?.data?.userById);
                }
            });
        }
    }, [id]);

    return (
        location.pathname !== '/reset-password' && (
            <nav>
                <div className="menu-toggle" onClick={toggleMenu}>
                    &#9776; {/* Hamburger icon */}
                </div>
                {id && (
                    <span style={{ color: 'white' }}>{`${userData?.firstname || ''} ${userData?.lastname || ''}`}</span>
                )}
                {!id ? (
                    <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
                        <Link to="/" onClick={() => toggleMenu()}>Home</Link>
                        <Link to="/about" onClick={() => toggleMenu()}>About Us</Link>
                        <Link to="/sign-up" onClick={() => toggleMenu()}>Build A Project</Link>
                        <Link to="/bootcamp" onClick={() => toggleMenu()}>Boot Camp</Link>
                        <Link to="/counseling-service" onClick={() => toggleMenu()}>Counseling / College</Link>
                        <Link to="/test-prep" onClick={() => toggleMenu()}>Test Prep (SAT/ACT)</Link>
                        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <Link to="/tutoring-service" onClick={() => toggleMenu()}>Tutoring Service</Link>
                            <Menu anchorEl={anchorEl} open={open} onClose={handleMouseLeave} MenuListProps={{ sx: { width: 150 } }}>
                                <MenuItem onClick={onClickItem}>AP Math</MenuItem>
                                <MenuItem onClick={onClickItem}>AP Physics</MenuItem>
                                <MenuItem onClick={onClickItem}>AP Chemistry</MenuItem>
                                <MenuItem onClick={onClickItem}>AP Biology</MenuItem>
                            </Menu>
                        </div>
                        {/* <Link to="/subscription" onClick={() => toggleMenu()}>Subscription</Link> */}
                        <Link to="/login" onClick={() => toggleMenu()}>Login</Link>
                        <Link to="/contact" onClick={() => toggleMenu()}>Contact Us</Link>

                    </div>
                ) :
                    <div className={`nav-link ${isMenuOpen ? "active" : ""}`}>
                        <Link to={`/tutoring-service?id=${id}`} onClick={() => toggleMenu()}>Tutoring Service</Link>
                        <Link to={`/test-prep?id=${id}`} onClick={() => toggleMenu()}>Test Prep (SAT/ACT)</Link>
                        <Link to={`/edit?id=${id}`} onClick={() => {
                            toggleMenu();
                            window.open("https://calendly.com/dreamcollegepath/30min", "_blank");
                        }}>
                            Book A Demo
                        </Link>
                        <Link to="/" onClick={() => toggleMenu()}>Logout</Link>
                    </div>}
            </nav>
        )
    );
};

export default Nav;
